<template>
  <div class="list_Hashtags" :class="{'margin-top-10': listHashtags.length > 0}">
    <el-tag
      v-for="item in listHashtags"
      :key="item.id"
      effect="dark"
      size="medium"
      class="priority inline-flex clickable"
      :style="`background-color: ${checkSelectedHashtag(item.id) ? '#ff000087' : item.colorCode}; color: white`"
      @click="selectTag(item)"
    >
      <i
        class="fal fa-users"
        v-if="item.groupTypeId === GROUPS.GROUP_TYPE_ID.CA_NHAN"
      ></i>
      <i
        class="fal fa-sitemap"
        v-if="item.groupTypeId === GROUPS.GROUP_TYPE_ID.DON_VI"
      ></i>
      <span>
        {{ item.groupName }}
      </span>
    </el-tag>
    <chuyen-xu-ly-hashtag-dialog :isOpen="isOpenCXLHashtagDialog" :hashTagSelected="hashTagSelected" @closeDialog="selectHashTagProcessType"/>

  </div>
</template>

<script>
  import groupsService from "../../../services/groupsService";
  import h from "../../../services/h";
  import constants from "../../../constants";
  import ChuyenXuLyHashtagDialog from "./chuyenXuLy-hashtag-dialog";


  export default {
    name: "hashtag-common",
    props: ["stepId", "groupTypeId", "selectedToUserDeptRoleIds"],
    components: {
      ChuyenXuLyHashtagDialog,
    },
    data() {
      return {
        listHashtags: [],
        listUserDeptInGroup: [],
        listHashtagsSelected: [],
        hashTagSelected: null,
        GROUPS: constants.GROUPS,
        listDetailGroups: {},
        isOpenCXLHashtagDialog: false,
      };
    },
    created() {
      if(this.selectedToUserDeptRoleIds && this.selectedToUserDeptRoleIds.length > 0)
      {
        this.listUserDeptInGroup = this.selectedToUserDeptRoleIds
      }
      this.doSearch().then(() => this.getListGroups(this.listHashtags));
    },
    methods: {
      isVinataba(){
        return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABA
      },

      selectTag(item) {
        this.hashTagSelected = item;
        if(this.checkSelectedHashtag(item.id)){
          this.listHashtagsSelected = h.findAll(this.listHashtagsSelected, item2 => item2 !== item.id);

          if(this.listHashtagsSelected.length > 0) {
            this.listUserDeptInGroup = this.getNonDuplicateCheckboxes(item.id, this.listHashtagsSelected);
          }
          else {
            this.listUserDeptInGroup = this.listDetailGroups[item.id];
          }
          this.$emit("unSelectTags",  this.populateData(item.processTypeSelect));
          // return groupsService.userDeptInGroup(item.id).then(res => {
          //   this.listUserDeptInGroup = res.data;
          //   this.$emit("unSelectTags",  this.populateData(item.processTypeSelect));
          // });
        } else {
          this.listUserDeptInGroup = this.listDetailGroups[item.id];

          //nếu đơn vị khác vinataba thì mở dialog cho chọn hình thức xử lý (chủ trì, phối hợp, nhận để biết)
          if (!this.isVinataba()) {
            this.isOpenCXLHashtagDialog = true;
          } else {
            this.listHashtagsSelected.push(this.hashTagSelected.id);
            this.$emit("selectTags",
              this.populateData(constants.PROCESS_TYPE.NHANDEBIET), constants.PROCESS_TYPE.NHANDEBIET);
          }
          // return groupsService.userDeptInGroup(item.id).then(res => {
          //   this.listUserDeptInGroup = res.data;
          // });
        }
      },

      //Nếu Hashtag được deselect có các checkbox chung với các active hashtag khác sẽ chỉ deselect phần không giao nhau
      getNonDuplicateCheckboxes(deSelectedHashtag,remainingHashtags) {
        const unselectTag = this.listDetailGroups[deSelectedHashtag];
        let result = [];
        for (const item2 of remainingHashtags) {
          const comparedArr = this.listDetailGroups[item2]
          result = result.concat(this.getUnmatchingValues(unselectTag,comparedArr))
        }
        return result;
      },

      getUnmatchingValues(result1,result2){
        return result1.filter(o1 => !result2.some(o2 => o1.departmentId === o2.departmentId));
      },

      setDetailGroups(key,list) {
        this.$set(this.listDetailGroups, key, list);
      },

      getDetailGroup(id){
        return groupsService.userDeptInGroup(id);
      },

      getListGroups(list){
        for (let item of list) {
          if(item.id) this.getDetailGroup(item.id).then((res) => this.setDetailGroups(item.id,res.data))
        }
      },

      selectHashTagProcessType(item) {
          this.isOpenCXLHashtagDialog = false;
        if(item.processTypeSelect === 0 || (item.processTypeSelect && item.hashTagSelected)){
          this.listHashtagsSelected.push(item.hashTagSelected.id);
          this.$emit("selectTags", this.populateData(item.processTypeSelect), item.processTypeSelect);
        }
      },

      checkSelectedHashtag(id){
        if (this.listHashtagsSelected && id) {
          return h.exists(this.listHashtagsSelected, item => item === id);
        }
        return false;
      },

      populateData(processTypeSelect) {
        let list = [];
        this.listUserDeptInGroup.forEach(item => {
          if (item.type === "caNhan") {
            let node = {
              handler: {
                id: item.userDeptRoleId,
                stepId: this.stepId,
                userView: {
                  deptName: item.userDeptName,
                  positionName: item.userPositionName,
                  userId: item.userId,
                  deptId: item.deptId,
                  roleId: item.roleId,
                  fullName: item.userFullName
                }
              },
              nodeType: constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE,
              processType: processTypeSelect
            };
            list.push(node);
          } else {
            let node = {
              department: {
                id: item.departmentId,
                deptName: item.departmentName
              },
              nodeType: constants.DEPARTMENT_TREE.NODE_TYPE.DEPT,
              processType: processTypeSelect
            };
            list.push(node);
          }
        });
        return list;
      },

      doSearch() {
        return groupsService.findAll().then(res => {
          this.listHashtags = res.data;
          if (this.groupTypeId != null)
            this.listHashtags = h.findAll(
              this.listHashtags,
              groups => groups.groupTypeId === this.groupTypeId
            );
        });
      }
    }
  };
</script>
x
<style scoped>
  .list_Hashtags .priority {
    padding-left: 14px;
    position: relative;
  }

  .list_Hashtags .priority::before {
    position: absolute;
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: white;
    top: 50%;
    left: 6px;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/chuyenXuLy-hashtag.vue